// Google Analytics の測定 ID。
// 環境変数（Vite の `import.meta.env.VITE_GA_MEASUREMENT_ID`）があればそれを優先し、
// 互換性のために既存のハードコード値をフォールバックとして保持する。
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-ZNEBDFEZZX';

// window.gtag の呼び出しシグネチャ定義
type GtagFn = (
    command: 'config' | 'event',
    targetId: string,
    params?: Record<string, unknown>,
) => void;

declare global {
    interface Window {
        // GA の gtag は外部スクリプト読み込み後に提供されるため optional
        gtag?: GtagFn;
    }
}

// 先頭スラッシュの有無を吸収して正規化したパスを返す
const normalizePath = (path: string): string => {
    if (!path) return '/';
    if (path.startsWith('/')) return path;
    return `/${path}`;
};

// SPA のルート変更に対応した仮想ページビューを GA に送信する
export const trackPageView = (path: string): void => {
    // SSR/ビルド時の安全策: ブラウザ環境でなければ何もしない
    if (typeof window === 'undefined') return;
    // 測定 ID が未設定の場合はスキップ
    if (!GA_MEASUREMENT_ID) return;
    // gtag がまだロードされていない場合はスキップ
    if (typeof window.gtag !== 'function') return;

    const pagePath = normalizePath(path);
    const pageLocation = window.location.href;

    // ルートに対応した従来のページビューに近い形で `config` を発行
    window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: pagePath,
        page_location: pageLocation,
    });
};

// 他の場所から測定 ID を参照できるようにエクスポート
export const gaMeasurementId = GA_MEASUREMENT_ID;

export {};
